/* eslint-disable import/prefer-default-export */
import {
  OFFBOOK_ADVANCE_TILE_PART_1,
  OFFBOOK_ADVANCE_TILE_PART_2,
} from './offbookAdvanceTile.constants';

export const offbookTitleGenerator = ({ loanVersion }) => (
  `${OFFBOOK_ADVANCE_TILE_PART_1} ${loanVersion === '21PPPLoan' ? 'First Draw' : 'Second Draw'} ${OFFBOOK_ADVANCE_TILE_PART_2}`
);
